import React from 'react';
import PropTypes from 'prop-types';

/**
 * SkeletonButton Component
 * 
 * A skeleton for loading buttons and interactive elements.
 * 
 * @param {Object} props
 * @param {string} props.size - Size variant: 'xs' | 'sm' | 'base' | 'lg' | 'xl'
 * @param {string} props.width - Width class or custom width
 * @param {boolean} [props.pill] - Whether to use pill/rounded styling
 * @param {string} props.className - Additional CSS classes
 * @component
 */
export default function SkeletonButton({ 
  size = 'base', 
  width = 'w-20', 
  pill = false,
  className = '' 
}) {
  const sizeClasses = {
    xs: 'h-6',    // text-xs
    sm: 'h-8',    // text-sm
    base: 'h-10', // text-base
    lg: 'h-11',   // text-lg
    xl: 'h-12'    // text-xl
  };

  const roundingClass = pill ? 'rounded-full' : 'rounded-md';

  return (
    <div
      className={`bg-gray-200 animate-pulse ${sizeClasses[size]} ${width} ${roundingClass} ${className}`}
      aria-label="Loading button"
    />
  );
}

SkeletonButton.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'base', 'lg', 'xl']),
  width: PropTypes.string,
  pill: PropTypes.bool,
  className: PropTypes.string,
};